// @flow strict
// $FlowFixMe[nonstrict-import]
import {EXTENSION_ID} from 'src/chat-extension/constants';

export const sendMessageToExtension = (type: string, payload: mixed) => {
  try {
    const chrome = window.chrome;
    if (!chrome || !chrome.runtime) {
      return;
    }
    chrome.runtime.sendMessage(EXTENSION_ID, {type, payload});
  } catch (error) {
    console.error('Error sending message to extension:', error);
  }
};
